module.exports = __webpack_public_path__ + "static/media/5C.6da51de8.svg";